module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAAACXBIWXMAAAsTAAALEwEAmpwYAAABGklEQVQokYXSPSvGYRQG8N/j+YcoKWarzI/FhyCLzdv0DMpgI2+TDZsPwET5BgxGg0nCoJQMipQyeH8M/3PX3ZOXU6f77brOuc59TqVer09jGd348rtVwu+xWGADV9hH8QcRPjCM9SLAW9j5h5TsCQtFyOuMyy70oQWNTOIHbvCMdrwnaQk0qay30kT8xDy2012RPcIR3lD9IeNxjm3+jDOc/1BXIwtE1JJLHcdFkM/CL3CK0RzbnPEOJyEn9bSKVzzkwERMmQ/D/7KWnPAcax1r6MmA/cohGYnzS8r4iV6shlcwhCnlGO5hADOYQwcaibgUQWZxiV1la9pCTQ1j2Ix6H6u1Wu1W2aeVIFzjAIOxn1D+7FEEbcXmN7ycR1kyLbu1AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/menus_icon/invoice.png
// module id = CkFW
// module chunks = 3